export default function PrivacyPolicy() {
  const styles = {
    container: {
      maxWidth: "800px",
      margin: "0 auto",
      padding: "2rem",
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      lineHeight: 1.6,
      color: "#333",
    },
    h1: {
      color: "#2c3e50",
      marginBottom: "1rem",
      fontSize: "2rem",
    },
    effectiveDate: {
      color: "#666",
      fontStyle: "italic",
      marginBottom: "2rem",
    },
    introduction: {
      marginBottom: "2rem",
    },
    section: {
      marginBottom: "2.5rem",
    },
    h2: {
      color: "#2c3e50",
      fontSize: "1.5rem",
      marginBottom: "1rem",
      paddingBottom: "0.5rem",
      borderBottom: "2px solid #eee",
    },
    paragraph: {
      marginBottom: "1rem",
    },
    list: {
      listStyleType: "disc",
      marginLeft: "1.5rem",
      marginBottom: "1rem",
    },
    listItem: {
      marginBottom: "0.5rem",
    },
    contactInfo: {
      backgroundColor: "#f8f9fa",
      padding: "1.5rem",
      borderRadius: "8px",
      marginTop: "1rem",
    },
    link: {
      color: "#007bff",
      textDecoration: "none",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>Privacy Policy – Work Permit (K Cement)</h1>
      <p style={styles.effectiveDate}>Effective Date: 11 April 2025</p>

      <p style={styles.introduction}>K Cement ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use the Work Permit mobile application ("App").</p>

      <section style={styles.section}>
        <h2 style={styles.h2}>1. Information We Collect</h2>
        <p style={styles.paragraph}>We only collect the following user data necessary for the App's functionality:</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Name</li>
          <li style={styles.listItem}>Phone number</li>
          <li style={styles.listItem}>Email address</li>
          <li style={styles.listItem}>Photo</li>
          <li style={styles.listItem}>Attach files</li>
          <li style={styles.listItem}>Location (while using the app)</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>2. Purpose of Data Collection</h2>
        <p style={styles.paragraph}>All collected information is used strictly to:</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Generate internal work permit documents</li>
          <li style={styles.listItem}>Identify and authenticate users</li>
          <li style={styles.listItem}>Facilitate branch-to-branch access control</li>
        </ul>
        <p style={styles.paragraph}>We do not use your data for marketing purposes, nor do we share it with third parties.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>3. Authentication</h2>
        <p style={styles.paragraph}>We use OAuth for secure user authentication.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>4. Data Security</h2>
        <p style={styles.paragraph}>We implement security measures to protect your personal information from unauthorized access or disclosure.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>5. Data Retention</h2>
        <p style={styles.paragraph}>User data is retained only for as long as necessary to support the functionality of the app.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>6. User Rights</h2>
        <p style={styles.paragraph}>You may:</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Request access to or correction of your personal data by contacting your HR representative</li>
          <li style={styles.listItem}>Request data deletion, subject to company policies</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>7. Contact Us</h2>
        <p style={styles.paragraph}>For questions or support, contact:</p>
        <div style={styles.contactInfo}>
          <p style={styles.paragraph}>
            Email:{" "}
            <a href="mailto:chorks@scg.com" style={styles.link}>
              chorks@scg.com
            </a>
          </p>
          <p style={styles.paragraph}>
            Phone:{" "}
            <a href="tel:+855888081453" style={styles.link}>
              +855 888081453
            </a>
          </p>
          <p style={styles.paragraph}>Address: Kampot Cement Co., Ltd.</p>
          <p style={styles.paragraph}>No.43, 5th Floor Maybank Tower,</p>
          <p style={styles.paragraph}>Preah Norodom Boulevard,</p>
          <p style={styles.paragraph}>Sangkat Phsar Thmey III,</p>
          <p style={styles.paragraph}>Khan Daun Penh,</p>
          <p style={styles.paragraph}>Phnom Penh 120203,</p>
          <p style={styles.paragraph}>Cambodia</p>
        </div>
      </section>
    </div>
  );
}
